import { render, staticRenderFns } from "./saveCarExhibitionProduct.vue?vue&type=template&id=4a222942&lang=html"
import script from "./saveCarExhibitionProduct.vue?vue&type=script&lang=js"
export * from "./saveCarExhibitionProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports